import React from 'react';
import { useProfile } from 'src/hooks/useProfile';
import { AppDispatch } from 'src/app/rootStore';
import { getGreetingMessage } from 'src/store/chatbot/chatbot.action';
import { useDispatch } from 'react-redux';
import SproutsAgent from '../SproutsAgent';

function AskPaulaButtonV3() {
  const [open, setOpen] = React.useState(false);
  const [buttonShowState, setButtonShowState] = React.useState(false);
  const { emailId } = useProfile();
  const dispatch = useDispatch<AppDispatch>();

  React.useEffect(() => {
    dispatch(getGreetingMessage({ email: emailId as string }));
  }, []);

  return (
    <>
      {!buttonShowState && (
        <div className="ask-paula-btn-wrapper">
          <div
            className="ask-paula-v3-btn-wrapper"
            onClick={() => {
              setOpen(true);
              setButtonShowState(true);
            }}
            role="button"
          >
            <div className="ask-paula-v3-btn">
              <div className="rounded-circle-div one" />
              <div className="rounded-circle-div three" />
              <div className="rounded-circle-div two" />
              <div className="drawer-line" />
              <p>Paula</p>
            </div>
            <div className="ask-paula-bg-svg">
              <AskPaulaSVG />
            </div>
          </div>
        </div>
      )}
      <div className="chatbot-chat-container-siri" style={{ right: open ? '0px' : '-100vw' }}>
        <SproutsAgent
          onClose={() => {
            setOpen(false);
            setTimeout(() => setButtonShowState(false), 300);
          }}
          show={open}
        />
      </div>
    </>
  );
}

export default AskPaulaButtonV3;

const AskPaulaSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="132"
      height="36"
      viewBox="0 0 132 36"
      fill="none"
    >
      <g filter="url(#filter0_di_81_6316)">
        <path
          d="M13 6C13 3.79086 14.7909 2 17 2L121 2C123.209 2 125 3.79086 125 6L125 24.8333C125 26.4481 125.971 27.9046 127.462 28.5256L131 30L7 30L10.5385 28.5256C12.029 27.9046 13 26.4481 13 24.8333L13 6Z"
          fill="#191918"
        />
        <path
          d="M13.5 6C13.5 4.067 15.067 2.5 17 2.5L121 2.5C122.933 2.5 124.5 4.067 124.5 6L124.5 24.8333C124.5 26.65 125.592 28.2885 127.269 28.9872L128.5 29.5L9.5 29.5L10.7308 28.9872C12.4077 28.2885 13.5 26.65 13.5 24.8333L13.5 6Z"
          stroke="url(#paint0_linear_81_6316)"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_81_6316"
          x="0"
          y="0"
          width="132"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-3" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_81_6316" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_81_6316"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.239216 0 0 0 0 0.239216 0 0 0 0 0.235294 0 0 0 0.84 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_81_6316" />
        </filter>
        <linearGradient
          id="paint0_linear_81_6316"
          x1="69"
          y1="2"
          x2="69"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6F6F5" />
          <stop offset="1" stopColor="#F6F6F5" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
